<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("tiertypes") }}</div>
        <div class="section-subTitle my-2">
          Manage All your Tier Types here.
        </div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Tier Type')"
          variant="default"
          :to="{ name: 'Add Tier Types' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-end mb-3"></div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header" style="justify-content: normal">
        <div class="pr-4">{{ $tc("status", 2) }}</div>

        <div>Cinema Types</div>
      </div>
      <ul class="desg-list">
        <li
          v-for="(tier_type, tierTypeKey) in tier_type_list"
          :key="tierTypeKey"
          class="light_grey_back"
          style="justify-content: normal"
        >
          <div class="d-flex align-items-center">
            <StatusDot
              :status="
                tier_type.tier_type_is_active === 'Y' ? 'active' : 'inactive'
              "
            />
            <router-link
              v-if="$can('update', 'Tier Type')"
              class="ml-4 clickable-icon"
              :to="{
                name: 'Edit Tier Types',
                params: { tier_type_id: tier_type.tier_type_id },
              }"
              v-b-tooltip="'Edit'" tabindex="0"
            >
              <i class="edit-pen icon blue-icon"></i>
            </router-link>
            <router-link
              class="ml-2 clickable-icon"
              :to="{
                name: 'View Tier Types',
                params: { tier_type_id: tier_type.tier_type_id },
              }"
              v-b-tooltip="'View'" tabindex="0"
            >
              <i class="icon-eye icon blue-icon"></i>
            </router-link>
          </div>
          <div class="ml-4">{{ tier_type.tier_type_name }}</div>
        </li>
      </ul>
    </div>
    <br />
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      tier_type_list: [],
    };
  },
  mounted() {
    this.getTierTypeList();
  },
  methods: {
    getTierTypeList: function () {
      MasterService.GetTierTypeList()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.tier_type_list = data.Records;
          } else {
            this.tier_type_list = [];
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TierTypeComponents/tierTypes.vue